import { Component, Input, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Employee } from 'src/app/models/Employees';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService } from 'src/app/services/translate.service';
import { VersionService } from 'src/app/services/version.service';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';
import { UtilityService } from 'src/app/util/utility.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-slide5',
  templateUrl: './slide5.component.html',
  styleUrls: ['./slide5.component.scss'],
})
export class Slide5Component implements OnInit {
  @Input() invitee: any;
  @Input() session: any;

  utilityService: UtilityService = new UtilityService();
  objectKeys = Object.keys;
  tncAccepted: boolean = true;
  envName: string = environment.envName;
  version: number = VersionService.version;
  constructor(public trans: TranslateService,
    private alert: AlertService,
    private toastService: ToastService,
    public auth: AuthService,
    public versionService: VersionService,


  ) { }

  ngOnInit() { }
  clickAddAchievements(item) {
    if (!item) {
      item = {};
    }
    this.alert.show2TextAlert("Achievement / Post", "Tell us about your achievements or roles — share your field and rank/designation to inspire others!", "Field", "Position", "Add", "Cancel", Object.keys(item)[0], item[Object.keys(item)[0]]).then((data) => {
      if (data.length == 2) {
        if (!this.auth.loggedInEmployee.user.user_pd.achievement) {
          this.auth.loggedInEmployee.user.user_pd.achievement = [];
        }
        if (Object.keys(item).length == 0) {
          this.auth.loggedInEmployee.user.user_pd.achievement.push({ [data[0]]: data[1] });
        } else {
          item[Object.keys(item)[0]] = data[1];
        }

      } else {
        this.toastService.warning("Please enter both field and position");
      }
    })
  }
  deleteAchievement(item) {
    this.alert.showAlert("Delete", "Are you sure you want to delete this item?", "Yes", "Cancel").then((data) => {
      this.auth.loggedInEmployee.user.user_pd.achievement.splice(this.auth.loggedInEmployee.user.user_pd.achievement.indexOf(item), 1);
    })
  }
 
}
